import { render, staticRenderFns } from "./RestockDetail.vue?vue&type=template&id=7a1089a6&"
import script from "./RestockDetail.vue?vue&type=script&lang=ts&"
export * from "./RestockDetail.vue?vue&type=script&lang=ts&"
import style0 from "./RestockDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports